"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatRpcError = formatRpcError;
exports.promisify = promisify;

function promisify(originalFn, thisArg) {
  const promisifiedFunction = async function () {
    for (var _len = arguments.length, callArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      callArgs[_key] = arguments[_key];
    }

    return new Promise((resolve, reject) => {
      const callback = (err, data) => {
        if (err === null || typeof err === "undefined") {
          reject(err);
        }

        resolve(data);
      };

      originalFn.apply(thisArg, [...callArgs, callback]);
    });
  };

  return promisifiedFunction;
}

function formatRpcError(error) {
  const message = error.message || "Failed or Rejected Request";
  let code = -32000;

  if (error && !error.code) {
    switch (message) {
      case "Parse error":
        code = -32700;
        break;

      case "Invalid request":
        code = -32600;
        break;

      case "Method not found":
        code = -32601;
        break;

      case "Invalid params":
        code = -32602;
        break;

      case "Internal error":
        code = -32603;
        break;

      default:
        code = -32000;
        break;
    }
  }

  const result = {
    code,
    message
  };
  return result;
}